import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from '../../../public/locales/en/common.json';
import frCommon from '../../../public/locales/fr/common.json';

const resources = {
  fr: {
    common: frCommon,
  },
  en: {
    common: enCommon,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr', // Langue par défaut
    debug: process.env.NODE_ENV === 'development',

    // Configuration du détecteur de langue
    detection: {
      // Ordre de détection des langues
      order: [
        'localStorage', // D'abord vérifier localStorage
        'navigator', // Puis la langue du navigateur
        'htmlTag', // Puis l'attribut lang du HTML
        'path', // Puis le chemin de l'URL
        'subdomain', // Puis le sous-domaine
      ],

      // Clé pour localStorage
      lookupLocalStorage: 'i18nextLng',

      // Langues supportées
      caches: ['localStorage'],

      // Exclure certaines langues de la détection
      excludeCacheFor: ['cimode'],
    },

    // Configuration des namespaces
    defaultNS: 'common',
    ns: ['common'],

    // Configuration de l'interpolation
    interpolation: {
      escapeValue: false, // React échappe déjà les valeurs
    },

    // Configuration des ressources
    react: {
      useSuspense: false, // Important pour Next.js
    },
  });

export default i18n;
